import { useEffect } from 'react';
import { useTenantsMutations } from '../../api/hooks/tenants/use-tenants-mutations';
import { useAuth } from '../../contexs/auth-context';
import env from '../../env';
import useActionCable from './use-action-cable';
import useChannel from './use-channel';
import { useTenantsQueries } from '../../api/hooks/tenants/use-tenants-queries';
import { useQueryClient } from '@tanstack/react-query';
import { TenantsDashboardResponse } from '../../api/types/tenants-types';

export default function useOpeningStateChannel() {
  const { authData } = useAuth();
  const { actionCable } = useActionCable(
    `${env.WEBSOCKET_URL}?token=${authData?.token}`,
  );
  const { subscribe, unsubscribe } = useChannel(actionCable);
  const { setDisconnected } = useTenantsMutations();
  const { fetchTenantsDashboard } = useTenantsQueries();
  const queryClient = useQueryClient();

  const refetchTenantsDashboard = () => {
    const tenantData = queryClient.getQueryData<TenantsDashboardResponse>([
      'tenantsDashboard',
    ]);

    if (
      fetchTenantsDashboard.isStale ||
      tenantData?.opening_state.disconnected // if the opening state is disconnected, we want to refetch regardless of the stale state
    ) {
      fetchTenantsDashboard.refetch();
    }
  };

  useEffect(() => {
    subscribe(
      { channel: 'OpeningStateChannel' },
      {
        received: () => {
          refetchTenantsDashboard();
        },
        connected: () => {
          refetchTenantsDashboard();
        },
        disconnected: () => {
          setDisconnected();
          // Action Cable will automatically try to reconnect
        },
      },
    );

    return () => {
      unsubscribe();
    };
  }, []);
}
